import { SectionTitleProps } from './types'

export function SectionTitle({
  as: Component = 'h2',
  children,
  className = '',
  ...props
}: SectionTitleProps) {
  return (
    <Component
      className={`font-heading text-2xl font-bold leading-8 tracking-normal md:text-[32px] md:leading-10 ${className}`}
      {...props}
    >
      {children}
    </Component>
  )
}
